var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"infrastructure"}},[_c('cloud-provider',{attrs:{"has-tab-focused":_vm.hasTabFocused}}),_c('cidr-block'),_c('update-arn')],1)}
var staticRenderFns = []

export { render, staticRenderFns }